module.exports = __webpack_public_path__ + "static/media/Owl2.216b58f4.ico";